var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollege(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.185,
    height: 17.181,
    viewBox: "0 0 17.185 17.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "college-svgrepo-com-2",
    transform: "translate(0 -0.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36098",
    "data-name": "Group 36098",
    transform: "translate(0 0.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36097",
    "data-name": "Group 36097",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6656",
    "data-name": "Rectangle 6656",
    width: 17.185,
    height: 0.529,
    transform: "translate(0 16.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64737",
    "data-name": "Path 64737",
    d: "M121.783,256.238v-8.051h-9.658v8.051h.529v-7.523h8.6v7.523Z",
    transform: "translate(-108.362 -239.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64738",
    "data-name": "Path 64738",
    d: "M145.074,272.716v-.529H144v.529h.273V278.9H144v.529h1.074V278.9H144.8v-6.184Z",
    transform: "translate(-139.167 -263.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64739",
    "data-name": "Path 64739",
    d: "M193.074,272.716v-.529H192v.529h.273V278.9H192v.529h1.074V278.9H192.8v-6.184Z",
    transform: "translate(-185.555 -263.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64740",
    "data-name": "Path 64740",
    d: "M241.074,272.716v-.529H240v.529h.273V278.9H240v.529h1.074V278.9H240.8v-6.184Z",
    transform: "translate(-231.944 -263.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64741",
    "data-name": "Path 64741",
    d: "M289.074,272.716v-.529H288v.529h.273V278.9H288v.529h1.074V278.9H288.8v-6.184Z",
    transform: "translate(-278.333 -263.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64742",
    "data-name": "Path 64742",
    d: "M337.074,272.6v-.529H336.8v0h-.529v0H336v.529h.273v6.184H336v.529h1.074v-.529H336.8V272.6Z",
    transform: "translate(-324.722 -262.933)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6657",
    "data-name": "Rectangle 6657",
    width: 10.741,
    height: 0.529,
    transform: "translate(3.222 7.523)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6658",
    "data-name": "Rectangle 6658",
    width: 3.491,
    height: 0.529,
    transform: "translate(0 10.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64743",
    "data-name": "Path 64743",
    d: "M84.468,5.777,78.56,3.9V.063h-.529V3.9l-5.907,1.88V7.309H84.468Zm-11.815,1V6.164l5.643-1.8,5.643,1.8V6.78Z",
    transform: "translate(-69.703 -0.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64744",
    "data-name": "Path 64744",
    d: "M274.95.188H272V.717h2.421v.814H272v.529h2.949Z",
    transform: "translate(-262.87 -0.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64745",
    "data-name": "Path 64745",
    d: "M314.421,25.531H312v.529h2.95V24.188h-1.07v.529h.541Z",
    transform: "translate(-301.528 -23.378)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6659",
    "data-name": "Rectangle 6659",
    width: 0.529,
    height: 0.537,
    transform: "translate(8.328 5.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6660",
    "data-name": "Rectangle 6660",
    width: 2.954,
    height: 0.529,
    transform: "translate(0.27 11.272) rotate(0.183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6661",
    "data-name": "Rectangle 6661",
    width: 2.954,
    height: 0.529,
    transform: "translate(0.27 13.967) rotate(0.183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6662",
    "data-name": "Rectangle 6662",
    width: 0.529,
    height: 1.074,
    transform: "translate(0.81 12.352)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6663",
    "data-name": "Rectangle 6663",
    width: 0.529,
    height: 1.074,
    transform: "translate(2.152 12.352)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6664",
    "data-name": "Rectangle 6664",
    width: 0.529,
    height: 1.074,
    transform: "translate(0.81 15.037)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6665",
    "data-name": "Rectangle 6665",
    width: 0.529,
    height: 1.074,
    transform: "translate(2.152 15.037)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6666",
    "data-name": "Rectangle 6666",
    width: 3.491,
    height: 0.529,
    transform: "translate(13.695 10.476)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6667",
    "data-name": "Rectangle 6667",
    width: 2.954,
    height: 0.529,
    transform: "translate(16.916 11.81) rotate(-179.817)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6668",
    "data-name": "Rectangle 6668",
    width: 2.954,
    height: 0.529,
    transform: "translate(13.965 13.967) rotate(0.183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6669",
    "data-name": "Rectangle 6669",
    width: 0.529,
    height: 1.074,
    transform: "translate(14.504 12.352)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6670",
    "data-name": "Rectangle 6670",
    width: 0.529,
    height: 1.074,
    transform: "translate(15.847 12.352)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6671",
    "data-name": "Rectangle 6671",
    width: 0.529,
    height: 1.074,
    transform: "translate(14.504 15.037)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6672",
    "data-name": "Rectangle 6672",
    width: 0.529,
    height: 1.074,
    transform: "translate(15.847 15.037)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollege);
export default __webpack_public_path__ + "static/media/college.fe8e16da2c3764abebfff7474d6a80d9.svg";
export { ForwardRef as ReactComponent };